// extracted by mini-css-extract-plugin
module.exports = {"brandmetricsContainer":"styles_brandmetricsContainer__1HzJD"};